import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment';

import { AiModelCatalogEntry, AiModelPrice, AiModelSourceLookup } from 'src/app/models/AiModelPrice';
import { ownErrorToastOptions } from 'src/app/shared/interceptors/http-error.interceptor';

/**
 * Criar, editar e excluir dão o próprio aviso (`OWN_ERROR_TOAST`): a trava do modelo vinculado a
 * Modelo do SMSFunnel (422) saía no toast do interceptor e de novo no da tela.
 */
@Injectable({ providedIn: 'root' })
export class AiModelPriceService {

  private cacheInvalidatedSubject = new Subject<void>();
  readonly cacheInvalidated$ = this.cacheInvalidatedSubject.asObservable();

  constructor(private http: HttpClient) { }

  list(): Observable<AiModelPrice[]> {
    return this.http.get<AiModelPrice[]>(`${environment.apiUrl}/ai-model-prices?no-paginate=1`);
  }

  /** Preço da tabela para UM modelo, com sugestões de id quando não encontra. */
  sourceLookup(provider: string, model: string, externalModelId?: string): Observable<AiModelSourceLookup> {
    let url = `${environment.apiUrl}/ai-model-prices/source-lookup`
      + `?provider=${encodeURIComponent(provider)}&model=${encodeURIComponent(model)}`;
    if (externalModelId) {
      url += `&external_model_id=${encodeURIComponent(externalModelId)}`;
    }
    return this.http.get<AiModelSourceLookup>(url);
  }

  /** Modelos que o cliente pode escolher — nome comercial, sem provider/modelo real. */
  catalog(): Observable<AiModelCatalogEntry[]> {
    return this.http.get<AiModelCatalogEntry[]>(`${environment.apiUrl}/ai-models/catalog`);
  }

  create(price: Partial<AiModelPrice>): Observable<AiModelPrice> {
    return this.http.post<AiModelPrice>(`${environment.apiUrl}/ai-model-prices`, price, ownErrorToastOptions());
  }

  update(id: string, price: Partial<AiModelPrice>): Observable<AiModelPrice> {
    return this.http.put<AiModelPrice>(`${environment.apiUrl}/ai-model-prices/${id}`, price, ownErrorToastOptions());
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/ai-model-prices/${id}`, ownErrorToastOptions());
  }

  invalidateCache(): void {
    this.cacheInvalidatedSubject.next();
  }
}
